import { render, staticRenderFns } from "./NavSide.vue?vue&type=template&id=570ca714&"
import script from "./NavSide.vue?vue&type=script&lang=js&"
export * from "./NavSide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports